import React, { useState } from 'react';
import { Mail, Smartphone } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import EmailLoginTab from './EmailLoginTab';
import MobileLoginTab from './MobileLoginTab';
import ForgotPassword from './ForgotPassword';
import AuthLayout from './AuthLayout';

const Login = () => {
  const [activeTab, setActiveTab] = useState('email');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { login } = useAuth();

  const handleLoginSuccess = (user, token) => {
    login(user, token);
  };

  if (showForgotPassword) {
    return <ForgotPassword onBack={() => setShowForgotPassword(false)} />;
  }

  return (
    <AuthLayout>
      <div className="w-full max-w-[500px] bg-white rounded-3xl shadow-xl border border-slate-100 p-6 sm:p-8 animate-scaleIn">
        {/* Logo */}
        <div className="text-center mb-6 animate-slideDown">
          <div className="inline-flex items-center justify-center mb-2">
            <img
              src="/images/logo.png"
              alt="QuickLook Logo"
              className="h-20 sm:h-24 w-auto"
            />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900">
            Sign in to Dashboard
          </h2>
          <p className="text-sm text-slate-400 mt-1">
            Enter your mobile number or email to continue
          </p>
        </div>

        {/* Tabs - Light Style */}
        <div className="flex gap-3 mb-6">
          <button
            onClick={() => setActiveTab('email')}
            className={`flex-1 py-3 px-4 rounded-xl font-semibold transition-all whitespace-nowrap text-sm sm:text-base flex items-center justify-center gap-2 ${
              activeTab === 'email'
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
            }`}
          >
            <Mail size={16} />
            Email
          </button>
          <button
            onClick={() => setActiveTab('mobile')}
            className={`flex-1 py-3 px-4 rounded-xl font-semibold transition-all whitespace-nowrap text-sm sm:text-base flex items-center justify-center gap-2 ${
              activeTab === 'mobile'
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
            }`}
          >
            <Smartphone size={16} />
            Mobile
          </button>
        </div>

        {/* Form Content */}
        <div>
          {activeTab === 'email' ? (
            <EmailLoginTab
              onLoginSuccess={handleLoginSuccess}
              onForgotPassword={() => setShowForgotPassword(true)}
            />
          ) : (
            <MobileLoginTab onLoginSuccess={handleLoginSuccess} />
          )}
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
